import { formatDate } from '@angular/common';
import { UserListItem } from '../../../../../services/auth-service.model';
import { UserTableRow } from './user-table-component.model';

const STATUSES: Record<number, { titleEn: string; titleAr: string }> = {
  1: { titleEn: 'Inactive', titleAr: 'غير نشط' },
  2: { titleEn: 'Active', titleAr: 'نشط' },
  3: { titleEn: 'Deleted', titleAr: 'محذوف' },
};

function formatRoles(user: UserListItem, isArabic: boolean): string {
  const roles = user.roles ?? [];
  if (roles.length === 0) return '';
  const first = isArabic ? roles[0].titleAr : roles[0].titleEn;
  return roles.length > 1 ? `${first} +${roles.length - 1}` : first;
}

function toUserTableRow(user: UserListItem, isArabic: boolean, locale: string): UserTableRow {
  // A user without a modification date shows the creation date as "last updated".
  const lastUpdated = user.lastModifiedOn || user.createdOn;

  return {
    id: user.id,
    fullName: `${user.firstName} ${user.lastName}`.trim(),
    roles: formatRoles(user, isArabic),
    status: STATUSES[user.status?.id ?? 2] ?? STATUSES[2],
    createdOn: user.createdOn ? formatDate(user.createdOn, 'mediumDate', locale) : '',
    lastUpdated: lastUpdated ? formatDate(lastUpdated, 'mediumDate', locale) : '',
  };
}

export function toUserTableRows(users: UserListItem[], isArabic: boolean, locale: string): UserTableRow[] {
  return users.map((u) => toUserTableRow(u, isArabic, locale));
}
